// extracted by mini-css-extract-plugin
export var headerDesktop = "Header-module--headerDesktop--012d0";
export var home = "Header-module--home--bb40b";
export var isBgFullSize = "Header-module--isBgFullSize--dfbb6";
export var links = "Header-module--links--1b5d3";
export var withBgImage = "Header-module--withBgImage--4db82";
export var withPageBg = "Header-module--withPageBg--b4d2a";